module.exports = __webpack_public_path__ + "img/3.813c301b.svg";